import api from './api';
import BaseService from './base.service';

export default class ProdCourseModuleService extends BaseService {
  constructor() {
    super('prod/modulos');
  }

  // formatLesson(lesson) {
  //   return {
  //     id: module.id,
  //     name: module.nome,
  //     order: module.numero_modulo,
  //     description: module.descricao,
  //     releaseDate: "19 de mai de 2020",
  //     classesCount: module.aulas.length,
  //   };
  // }

  async get_lessons(moduleId) {
    try {
      const response = await api.get(`${this.resource}/${moduleId}/get_aulas/`);
      return response.data;
    } catch (err) {
      return err;
    }
  }
}
